<template>
  <li
    class="relative col-span-1 bg-white border-2 border-gray-300 border-dashed rounded-lg"
  >
    <button
      @click.prevent="removePerson"
      class="absolute top-[5px] right-[5px]"
    >
      <svg
        class="w-4 h-4 text-gray-400"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button>
    <div class="flex items-center justify-between w-full p-6 space-x-6">
      <div class="flex-1 truncate">
        <div class="-space-y-px rounded-md shadow-sm isolate">
          <div
            class="relative px-3 py-2 border border-gray-300 rounded-md rounded-b-none focus-within:z-10 focus-within:ring-1 focus-within:ring-transparent focus-within:border-transparent"
          >
            <label for="name" class="block text-xs font-medium text-gray-700">{{
              t("question.input.name")
            }}</label>
            <input
              type="text"
              v-model="person.name"
              name="name"
              id="name"
              class="block p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
              placeholder=""
            />
          </div>
          <div
            class="relative px-3 py-2 border border-gray-300 rounded-md rounded-t-none rounded-b-none focus-within:z-10 focus-within:ring-1 focus-within:ring-transparent focus-within:border-transparent"
          >
            <label
              for="email"
              class="block w-full text-xs font-medium text-gray-700"
              >{{ t("question.input.email") }}</label
            >
            <input
              v-model="person.email"
              type="email"
              name="email"
              id="email"
              class="block w-full p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
              placeholder=""
            />
          </div>
          <div
            class="relative px-3 py-2 border border-gray-300 rounded-md rounded-t-none rounded-b-none focus-within:z-10 focus-within:ring-1 focus-within:ring-transparent focus-within:border-transparent"
          >
            <label
              for="dob"
              class="block w-full text-xs font-medium text-gray-700"
              >{{ t("question.input.dob") }}</label
            >
            <input
              v-model="person.dob"
              max="2003-01-01"
              type="date"
              name="dob"
              id="dob"
              class="block w-full p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
              placeholder=""
            />
          </div>
          <div
            class="relative px-3 py-2 border border-gray-300 rounded-md rounded-t-none rounded-b-none focus-within:z-10 focus-within:ring-1"
          >
            <label
              for="address"
              class="block w-full text-xs font-medium text-gray-700"
              >{{ t("question.input.address") }}</label
            >
            <input
              v-model="person.address"
              type="text"
              name="address"
              id="address"
              class="block w-full p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
              placeholder=""
            />
          </div>
          <div
            class="relative px-3 py-2 border border-gray-300 rounded-md rounded-t-none focus-within:z-10 focus-within:ring-1 focus-within:ring-transparent focus-within:border-transparent"
          >
            <label
              for="share"
              class="block w-full text-xs font-medium text-gray-700"
              >{{ t("question.input.share") }}</label
            >
            <input
              v-model="person.share"
              type="number"
              name="share"
              id="share"
              class="block w-full p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
              placeholder="Please enter share percent"
            />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { MailIcon, PhoneIcon } from "@heroicons/vue/solid";
import { useI18n } from "vue-i18n";

export default {
  name: "Shareholder",
  components: {
    MailIcon,
    PhoneIcon,
  },
  props: {
    person: {
      type: Object,
      default: {
        name: "",
        dob: "",
        address: "",
        share: 0,
      },
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const removePerson = () => {
      emit("remove", props.person);
    };
    return {
      t,
      removePerson,
    };
  },
};
</script>
